import React, { RefObject } from 'react';
import styled from 'styled-components';
import { SparePart } from '../interfaces/Item';
import { AspectRatioImage } from './AspectRatioImage';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { StyledColorDot } from './ItemFamilyStyles';

const Horizontal = styled.div`
  display: flex;
`;
// eslint-disable-next-line
const InnerHorizontal = styled(Horizontal as any)`
  display:block;
  margin-top: 10px;
  align-items: center;
`;
// eslint-disable-next-line
const ItemDisplayLayout = styled(Horizontal as any)`
  margin-bottom: 24px;
`;

export const ItemImage = styled.div`
  display: flex;
  width: 56px;
  height: 56px;
  align-items: center;
  margin-inline-end: 16px;
`;
const ImageWrapper = styled.div`
  display: flex;
  width: 85px;
  height: 85px;
  align-items: center;
  margin-inline-end: 20px;
  flex-direction: column;
`;

const ItemContentWrapper = styled.div`
  flex: 1;
`;
const H = styled.span`
  display: block;
  speak: spell-out;
`;

const SROnly = styled.span`
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export interface ItemProps {
  item: SparePart;
  itemFamily?: SparePart[];
  enableOptions?: boolean;
  showImageDot?: boolean;
  onFamilyClick?: Function;
  onClickItem?: Function;
  onChangeSearch?: Function;
  onSetSelectedItem?: Function;
  setSearch?: Function;
  refInput?: RefObject<HTMLElement>;
}

export const Item: React.FC<ItemProps> = ({
  item,
  showImageDot,
  itemFamily: _itemFamily,
  children,
}): JSX.Element => {
  const { t } = useTranslation();
  const { id, imageSrc } = item;
  const idWithSpaces = id?.toString().split('').join(' ');

  return (
    <ItemDisplayLayout as="li" className="item">
      <ImageWrapper>
        <AspectRatioImage src={imageSrc} alt="" />
        {showImageDot && item.color && <StyledColorDot color={item.color} />}
      </ImageWrapper>
      <ItemContentWrapper>
        <SROnly aria-label={idWithSpaces}>
          {t('spareParts.a11yText.itemNumber', {
            id: idWithSpaces,
          })}
        </SROnly>
        <H className="h3" aria-hidden="true">
          {id}
        </H>
        <InnerHorizontal>
          {children}
        </InnerHorizontal>
      </ItemContentWrapper>
    </ItemDisplayLayout>
  );
};
export default Item;
